import {React, styled} from 'common'
import {Images} from 'appearance'
import IconButton from '@mui/material/IconButton'
import {useNavigate} from 'services/hooks'

const Logo = () => {
    const navigate = useNavigate()
    return (
        <IconButton onClick={() => navigate('/')}>
            <LogoImage src={Images.LOGO} />
        </IconButton>
    )
}

export default Logo

const LogoImage = styled.img`
    width: 50px;
`
